import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AlarmIcon(props: IconProps) {
    return <Icon {...props} iconKey={"alarm"}/>
}
